'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

exports.isAbsent = isAbsent;
exports.isBlank = isBlank;
exports.isDefined = isDefined;
exports.isEmpty = isEmpty;
exports.isNull = isNull;
exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isPresent = isPresent;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*  eslint-disable no-use-before-define */

function isAbsent(value) {
  return !isDefined(value) || isNull(value) || (0, _isNan2.default)(value);
}

var BLANK_REGEX = /^\s*$/;
function isBlank(value) {
  return isAbsent(value) || typeof value === 'string' && BLANK_REGEX.test(value);
}

function isDefined(value) {
  return value !== undefined;
}

function isEmpty(value) {
  if (!isObject(value)) {
    return isAbsent(value) || value === '';
  }

  for (var prop in value) {
    // eslint-disable-line
    return false;
  }

  return true;
}

function isNull(value) {
  return value === null;
}

function isNumber(value) {
  return !(0, _isNan2.default)(value) && (0, _isFinite2.default)(value);
}

function isObject(value) {
  return value === Object(value);
}

function isPresent(value) {
  return isDefined(value) && !isNull(value) && !(0, _isNan2.default)(value);
}